"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Box = _interopRequireDefault(require("@mui/material/Box"));

var _utils = require("@mui/utils");

var _jsxRuntime = require("react/jsx-runtime");

var Announcer = function Announcer(_ref) {
  var _ref$message = _ref.message,
      message = _ref$message === void 0 ? "" : _ref$message;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    sx: _utils.visuallyHidden,
    role: "alert",
    children: message
  });
};

var _default = Announcer;
exports.default = _default;